export enum CapabilityEnum {
  list = "main.list",
  general = "general",
  detail = "detail",
  create = "create",
  update = "update",
  delete = "delete",
  exportExcel = "export",
  inboundExport = "export.TRAVEL_SIM",
  outboundExport = "export.GOGO_SIM",
  filterPrefix = "filter.",
  phoneFilter = "filter.phoneNumber",
  nameFilter = "filter.name",
  codeFilter = "filter.code",
  refFilter = "filter.ref",
  statusFilter = "filter.status",
  partnerFilter = "filter.partner",
  storeFilter = "filter.store",
  userFilter = "filter.user",
  dateFilter = "filter.date",
  carrierFilter = "filter.carrier",
  permissionFilter = "filter.permission",
  supplierFilter = "filter.supplier",
  packageFilter = "filter.package",
  staffFilter = "filter.staff",
  searchAndRedoFilter = "filter",
  airTimeFilter = "filter.airtime",
  zodiacFilter = "filter.zodiac",
  destinyFilter = "filter.destiny",
  numerologyFilter = "filter.numerology",
  numberTypeFilter = "filter.skus",
  nationFilter = "filter.nation",
  userStoreMain = "user.store.main.list",
  userStaffMain = "user.staff.main.list",
  userChainMain = "user.chain.main.list",
  userChainFilter = "filter.user.chain",
  userStoreFilter = "filter.user.store",
  systemUserFilter = "filter.system.user",
  internalFileAllowance = "download.file.internal",
}
